import { baseUrl_SPB } from "../../../../../BaseUrl";

export const fetchExpenseById = async (authToken, id) => {
  try {
    // Construct the URL matching your @RequestParam String basiqUserId
    const url = `${baseUrl_SPB}/api/v1/reimburse/retrieveexpensesbyid?reimbursementId=${encodeURIComponent(id)}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${authToken}`, // Included if your backend enforces JWT verification
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Spring Boot backend responded with status: ${response.status}`);
    }

    const jsonResponse = await response.json();

    // Handle both cases: if your Spring Boot wrapper returns the raw Basiq object 
    // containing a "data" array, or if it unpacks it and returns the array directly.
    if (jsonResponse && jsonResponse.data) {
      return jsonResponse.data; 
    }
    
    return Array.isArray(jsonResponse) ? jsonResponse : [];

  } catch (error) {
    console.error('Error in  service:', error);
    throw error; // Let the calling component catch and handle the loading state safely
  }
};